import React, { useState } from "react";
import {  FaMinus, FaPlus, FaUserMd, FaChartLine, FaUsers,FaHandHoldingUsd, FaMoneyCheckAlt, FaHospital, FaLightbulb, FaBusinessTime, FaSearchDollar, FaHandshake, FaFileInvoiceDollar, FaBalanceScale, FaIndustry, FaCoins, FaGlobe, FaChartBar } from "react-icons/fa";

import Medpalm from "../../../assests/Healthcaretechnology/HealthcareVenture.jpg";
import { motion } from "framer-motion";
import Footer from "../../../Component/Fooder";
const services = [
    {
        "title": "Healthcare Startup Funding",
        "description":
            "Invest in early-stage healthcare startups that are pioneering advancements in digital health, biotechnology, and medical devices. Funding supports the development of cutting-edge solutions, including AI-powered diagnostics, telehealth platforms, wearable health monitoring devices, and personalized medicine. These investments accelerate innovation, enhance patient care, and drive long-term industry transformation by bringing disruptive healthcare technologies to market."
    },
    {
        "title": "Private Equity in Healthcare",
        "description":
            "Acquire and expand well-established healthcare companies to drive operational efficiency, enhance service quality, and maximize market growth. Private equity investments focus on improving patient care, optimizing hospital and clinical workflows, and scaling businesses in pharmaceuticals, medical technology, healthcare services, and long-term care facilities. Through strategic restructuring and technology adoption, private equity firms help healthcare organizations achieve sustainable financial and operational success."
    },
    {
        "title": "Mergers & Acquisitions",
        "description":
            "Facilitate strategic mergers and acquisitions (M&A) to strengthen competitive positioning in the healthcare sector. M&A activities enable organizations to streamline operations, expand service offerings, and integrate innovative medical technologies. By consolidating healthcare providers, pharmaceutical companies, and medical technology firms, M&A deals create synergies that enhance efficiency, reduce costs, and improve overall patient outcomes. Additionally, these transactions support market expansion and regulatory compliance in an evolving healthcare landscape."
    },
    {
        "title": "MedTech & Biotech Investments",
        "description":
            "Fund groundbreaking medical technology and biotechnology initiatives that drive the future of healthcare. Investments in MedTech accelerate the development of AI-assisted medical devices, robotic surgical systems, and next-generation imaging technologies. Meanwhile, biotech investments support advancements in gene therapy, regenerative medicine, and precision oncology. These innovations have the potential to revolutionize diagnostics, treatment methodologies, and patient recovery, ultimately improving healthcare accessibility and effectiveness."
    },
    {
        "title": "Telehealth & Digital Health Ventures",
        "description":
            "Support the growth of AI-driven telemedicine platforms, remote patient monitoring solutions, and digital therapeutics. Digital health investments play a crucial role in making healthcare more accessible, reducing costs, and enhancing patient engagement. By funding cloud-based healthcare platforms, mobile health applications, and virtual care technologies, investors enable providers to manage chronic diseases more effectively, improve care coordination, and offer real-time, data-driven medical interventions."
    },
    {
        "title": "Healthcare Infrastructure & Real Estate",
        "description":
            "Invest in the development, expansion, and modernization of hospitals, outpatient clinics, specialty medical centers, and healthcare real estate. These investments help ensure sustainable growth, improve patient accessibility, and integrate cutting-edge medical technologies into healthcare facilities. Strategic funding in healthcare infrastructure supports the construction of smart hospitals, long-term care facilities, and urgent care centers, driving efficiency, enhancing patient experiences, and meeting the growing demand for high-quality medical services."
    }
]

const features = [
    { icon: <FaHandHoldingUsd className="text-[#2a627a] text-lg" />, text: "Early-stage and growth capital for healthcare startups." },
    { icon: <FaChartLine className="text-[#2a627a] text-lg" />, text: "Data-driven investment strategies for long-term returns." },
    { icon: <FaMoneyCheckAlt className="text-[#2a627a] text-lg" />, text: "Private equity-backed acquisitions for market expansion." },
    { icon: <FaUserMd className="text-[#2a627a] text-lg" />, text: "Specialized healthcare investor networks and partnerships." },
    { icon: <FaHospital className="text-[#2a627a] text-lg" />, text: "Infrastructure investments in hospitals and clinics." },
    { icon: <FaLightbulb className="text-[#2a627a] text-lg" />, text: "Support for MedTech innovations and biotech breakthroughs." }
];

const benefits = [
    { icon: <FaBusinessTime className="text-[#2a627a] text-lg" />, text: "Accelerates healthcare innovation through strategic funding." },
    { icon: <FaUsers className="text-[#2a627a] text-lg" />, text: "Creates job opportunities in the healthcare sector." },
    { icon: <FaSearchDollar className="text-[#2a627a] text-lg" />, text: "Boosts R&D in pharmaceuticals, biotech, and medical devices." },
    { icon: <FaHandshake className="text-[#2a627a] text-lg" />, text: "Facilitates collaborations between investors and healthcare leaders." },
    { icon: <FaFileInvoiceDollar className="text-[#2a627a] text-lg" />, text: "Enhances financial stability of healthcare businesses." },
    { icon: <FaBalanceScale className="text-[#2a627a] text-lg" />, text: "Promotes scalable, sustainable healthcare models." }
];
const cmsFeatures = [
    { icon: <FaIndustry className="text-[#2a627a] text-lg" />, text: "Venture Capitalist – Identifies and funds high-potential healthcare startups." },
    { icon: <FaCoins className="text-[#2a627a] text-lg" />, text: "Private Equity Partner – Invests in and scales established healthcare firms." },
    { icon: <FaGlobe className="text-[#2a627a] text-lg" />, text: "Healthcare Market Analyst – Analyzes trends to guide investments." },
    { icon: <FaChartBar className="text-[#2a627a] text-lg" />, text: "Investment Strategist – Designs healthcare investment portfolios." },
    { icon: <FaHandshake className="text-[#2a627a] text-lg" />, text: "M&A Specialist – Manages healthcare mergers and acquisitions." },
    { icon: <FaUserMd className="text-[#2a627a] text-lg" />, text: "Healthcare Consultant – Advises investors on market opportunities." }
];
const HVC = () => {
    const [openIndex, setOpenIndex] = useState(0);
    return (
        <>
            <div className="min-h-screen mt-10 p-8 bg-white w-full flex flex-col items-center shadow-lg rounded-lg">
                {/* <div className="min-h-screen mt-10 p-8 bg-gradient-to-t from-[#78ffa5] to-[#03ab3b] w-full flex flex-col items-center shadow-lg rounded-lg"> */}
                {/* Header Section */}
                <div className=" text-center w-full ">
                    <h1 className="font-semibold text-[30px] bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800 flex justify-center items-center"> Healthcare Venture Capital & Private Equity - <span className="text-gray-800"> HIKEHEALTH GS</span> </h1>
                    <p className="text-gray-800 mt-3 text-sm">
                        "Driving innovation and growth in healthcare by investing in transformative technologies, startups, and scalable medical solutions."
                    </p>
                </div>

                {/* What is Blue Button 2.0? */}
                <section className="mt-8 flex flex-col md:flex-row  bg-gray-300 p-6 bg-opacity-80 drop-shadow-2xl rounded-xl items-center">
                    <img draggable={false}src={Medpalm} alt="Healthcare Tech" className="rounded-lg shadow-xl  w-full md:w-1/5" />
                    <div className="md:ml-6 mt-2 md:mt-0">
                        <h2 className="text-[30px] font-extrabold text-[#2a627a]">What is Healthcare Venture Capital & Private Equity?</h2>
                        <p className="text-gray-800 mt-2 text-sm text-wrap">
                        Healthcare Venture Capital (VC) and Private Equity (PE) involve investing in innovative healthcare startups, medical technology companies, and biotech firms to drive growth, innovation, and scalability. These investments support cutting-edge medical advancements, digital health solutions, and healthcare infrastructure development.

At HIKEHEALTH GS, we specialize in funding, scaling, and accelerating high-potential healthcare businesses, ensuring they have the resources to revolutionize patient care and medical innovation.
                        </p>
                    </div>
                </section>

                {/* Role in AI&Machine */}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800 p-2">
                        Role in Healthcare Venture Capital & Private Equity
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {cmsFeatures.map((item, index) => (
                            <motion.div
                                key={index}
                                className="flex items-center space-x-3 bg-gray-300 bg-opacity-100 p-4 rounded-lg shadow"
                                initial={{ opacity: 0, y: 30, filter: "blur(10px)" }} // Fade-in + Blur + Bounce effect
                                whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
                                transition={{ duration: 0.8, ease: "easeOut", delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}
                            >
                                {item.icon}
                                <span className="text-gray-800 text-sm font-medium">{item.text}</span>
                            </motion.div>
                        ))}
                    </div>
                </section>

                {/* Key Features Section */}
                <section className="mt-6 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800 p-2">
                        Key Features
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {features.map((item, index) => (
                            <motion.div
                                key={index}
                                className="flex items-center space-x-3 bg-gray-300 p-4 rounded-lg shadow"
                                initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }} // Left & Right split
                                whileInView={{ opacity: 1, x: 0 }} // Move to center
                                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}
                            >
                                {item.icon}
                                <p className="text-gray-800 text-sm font-medium">{item.text}</p>
                            </motion.div>
                        ))}
                    </div>
                </section>


                {/* Benefits Section */}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800">
                        Benefits
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {benefits.map((item, index) => (
                            <motion.div key={index} className="flex items-center space-x-3 bg-gray-300 p-4 rounded-lg shadow" initial={{ opacity: 0, scale: 0.8, y: 40 }}
                                whileInView={{ opacity: 1, scale: 1, y: 0 }}
                                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}>

                                {item.icon}
                                <p className="text-gray-800 text-sm font-medium">{item.text}</p>
                            </motion.div>
                        ))}
                    </div>
                </section>




                {/* Services Section */}
                <section className="mt-12 w-full  mx-auto">
                    {/* Heading */}
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800">
                        Discover Our Services
                    </h2>

                    {/* Service List */}
                    <div className=" grid grid-cols-1 md:grid-cols-1 gap-6 mt-4 max-w-5xl mx-auto px-4 ">
                        {services.map((service, index) => (
                            <div key={index} className="border-b border-gray-800">
                                {/* Service Title */}
                                <button
                                    className=" w-full flex justify-between items-center py-4 text-lg font-medium text-gray-800 focus:outline-none"
                                    onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                                >
                                    {service.title}
                                    {openIndex === index ? (
                                        <FaMinus className="text-red-500" />
                                    ) : (
                                        <FaPlus className="text-gray-600" />
                                    )}
                                </button>

                                {/* Service Description (Expandable with Animation) */}
                                <motion.div
                                    initial={{ height: 0, opacity: 0 }}
                                    animate={openIndex === index ? { height: "auto", opacity: 1 } : { height: 0, opacity: 0 }}
                                    transition={{ duration: 0.3, ease: "easeInOut" }}
                                    className="overflow-hidden"
                                >
                                    <p className="text-gray-600 text-sm pb-4">{service.description}</p>
                                </motion.div>
                            </div>
                        ))}
                    </div>
                </section>

            </div>
            <Footer />
        </>
    );
};

export default HVC;
